import { FC } from 'react';

import { Box } from '@mantine/core';

import { CompanyProfile } from 'models';

import { LocationTeaser } from 'components/company-profile/components/LocationTeaser';
import { ProfileRowCarousel } from 'components/company-profile/components/ProfileRow';
import { Socials } from 'components/company-profile/components/Socials';
import { useShowCompanyInfo } from 'components/company-profile/hooks/use-show-company-info';
import { Section } from 'components/section/Section';
import { SectionTitle } from 'components/section/SectionTitle';

import cx from './styles.module.scss';

const Contact: FC<{ company: CompanyProfile }> = ({ company }) => {
    const { shownLocations: locations } = useShowCompanyInfo(company);

    const hasLocations = locations.length > 0;

    return (
        <Section id="contact">
            <Box className={cx.contactHeader} data-stacked={!hasLocations || undefined}>
                <SectionTitle w="auto">Contact</SectionTitle>
                <Socials
                    company={company}
                    asButtons={!hasLocations}
                    className={hasLocations ? cx.socials : undefined}
                />
            </Box>

            {hasLocations && (
                <ProfileRowCarousel>
                    {locations.map((location) => (
                        <LocationTeaser key={location.id} {...location} company={company} />
                    ))}
                </ProfileRowCarousel>
            )}
        </Section>
    );
};

export { Contact };
